import React, {useState} from "react";
import { Column, Columns, Modal, Section, Title } from "@allxsmith/bestax-bulma";
import QuoteItem from "./QuoteItem";


export default function CreateDuplicateQuoteModal({open, setOpen, rental, onQuoteDuplicate}){

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            active={open}
            onClose={() => {
                setOpen(false)}
            }
            closeOnBlur

        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Duplicate A Quote</Title>
                        </Column>
                    </Columns>
                    {rental.quotes.filter(quote => quote.rental).map(quote => (
                        <QuoteItem
                            quote={quote}
                            onDuplicate={onQuoteDuplicate}
                        />
                    ))}
                </Section>
            </Modal.Content>
        </Modal>
    );
}